import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Picker } from "../../root/components/common";
import { OPERATION_MODES } from "../../root/constants";


export const OperationModeSelect = ({ onChange, operationMode = OPERATION_MODES.snaptrap }) => {
    const [mode, setMode] = useState(operationMode);
    const { locale } = useSelector((state) => state.main);

    return (
        <Picker
            onChange={(v) => {
                onChange(v);
                setMode(v);
            }}
            value={mode}
            options={{
                [OPERATION_MODES.movement]: locale.devices.operationMode.movement,
                [OPERATION_MODES.insect]: locale.devices.operationMode.insect,
                [OPERATION_MODES.snaptrap]: locale.devices.operationMode.snaptrap
            }}
        />
    );
};
